import React from 'react';
import { connect } from 'react-redux';
import { Alert } from 'reactstrap';
import moment from 'moment-timezone';
import { downloadOutgoingCalls } from '../../actions/Calls';
import SortIcons from '../ProposalsSortIcons';
import TableRowOut from './TableRowOut';
import logoLoading from '../../Res/logo-loading.gif';
import utils from '../../lib/utils';

const AllCalls = ({ calls, onSort, sortValue, user, tab, isLoading }) => {
  const displayTimeZone = utils.getUserDisplayTimeZone();
  const timeZoneAbbr = moment().tz(displayTimeZone).format('z');

  return (
    <div className="table-header-fixed">
      <table>
        <thead>
          <tr>
            <th className="cursor-pointer" onClick={() => calls?.length > 0 && onSort('callerId')}>
              Caller <SortIcons sortObj={sortValue} sortName="callerId" />
            </th>
            <th
              className="cursor-pointer"
              onClick={() => calls?.length > 0 && onSort('destination')}
            >
              Destination <SortIcons sortObj={sortValue} sortName="destination" />
            </th>
            <th className="cursor-pointer" onClick={() => calls?.length > 0 && onSort('callType')}>
              Call Type <SortIcons sortObj={sortValue} sortName="callType" />
            </th>
            <th
              className="cursor-pointer"
              onClick={() => calls?.length > 0 && onSort('serialNumber')}
            >
              Serial Number <SortIcons sortObj={sortValue} sortName="serialNumber" />
            </th>
            <th className="cursor-pointer" onClick={() => calls?.length > 0 && onSort('displayName')}>
              Edge Device Name <SortIcons sortObj={sortValue} sortName="displayName" />
            </th>
            <th className="cursor-pointer" onClick={() => calls?.length > 0 && onSort('epikBox.location.locationName')}>
              Location <SortIcons sortObj={sortValue} sortName="epikBox.location.locationName" />
            </th>
            {tab === 'all' && (
              <th onClick={() => calls?.length > 0 && onSort('direction')}>
                Direction
                <SortIcons sortObj={sortValue} sortName="direction" />
              </th>
            )}
            <th onClick={() => calls?.length > 0 && onSort('companyId')}>
              Company
              <SortIcons sortObj={sortValue} sortName="companyId" />
            </th>
            <th className="cursor-pointer" onClick={() => calls?.length > 0 && onSort('createdOn')}>
              Date <SortIcons sortObj={sortValue} sortName="createdOn" />
            </th>
            <th className="cursor-pointer" onClick={() => calls?.length > 0 && onSort('createdOn')}>
              Time ({timeZoneAbbr}) <SortIcons sortObj={sortValue} sortName="createdOn" />
            </th>
            <th className="cursor-pointer" onClick={() => calls?.length > 0 && onSort('duration')}>
              Duration <SortIcons sortObj={sortValue} sortName="duration" />
            </th>
            {/* <th>Actions</th> */}
          </tr>
        </thead>
        <tbody>
          {isLoading ? (
            <tr>
              <td colSpan={tab === 'all' ? 11 : 10}>
                <div className="calls error-msg d-flex flex-column justify-content-center align-items-center">
                  <img src={logoLoading} className="loading-logo-sm" alt="loading" />
                  <p className="text-align-center">Loading, Please wait...</p>
                </div>
              </td>
            </tr>
          ) : calls?.length > 0 ? (
            calls.map((item, i) => <TableRowOut calls={item} key={i} user={user} tab={tab} />)
          ) : (
            <tr>
              <td colSpan={tab === 'all' ? 11 : 10}>
                <Alert rowSpan={6} color="info">
                  No Calls Found
                </Alert>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  downloadOutgoingCalls: (token, callID) => dispatch(downloadOutgoingCalls(token, callID)),
});

export default connect(mapDispatchToProps)(AllCalls);
